module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Regular.eccb0c70.woff2";